// style
import "../scss/index.scss";
{
    // menu
    const btn = document.getElementById("js-menu-toggle");
    const btnClose = document.getElementById("js-menu-close");
    const toggleMenu = (open) => {
        document.body.classList.toggle("menu-open", open);
    };
    const eventType = "ontouchstart" in window ? "touchstart" : "click";
    btn?.addEventListener(eventType, () => toggleMenu(!document.body.classList.contains("menu-open")));
    btnClose?.addEventListener(eventType, () => toggleMenu(false));
}
{
    document.addEventListener("DOMContentLoaded", () => {
        // 全てのセットを取得
        const categorySets = document.querySelectorAll(".hl-block-blue.sp-only");
        categorySets.forEach((toggleButton) => {
            // ボタンの次にある .list-category を取得（構造に依存）
            const categoryList = toggleButton.nextElementSibling;
            if (!categoryList || !categoryList.classList.contains("list-category"))
                return;
            // ---------- カテゴリ全体のトグル ----------
            toggleButton.addEventListener("click", () => {
                categoryList.classList.toggle("is-active");
                toggleButton.classList.toggle("is-open");
            });
            // ---------- 子リスト（年→月）のトグル ----------
            const parents = categoryList.querySelectorAll(".has-child");
            parents.forEach((parent) => {
                const trigger = parent.querySelector("a");
                const childList = parent.querySelector(".list-category-child");
                if (!trigger || !childList)
                    return;
                trigger.addEventListener("click", (e) => {
                    e.preventDefault();
                    parent.classList.toggle("is-open");
                    childList.classList.toggle("is-active");
                });
            });
        });
    });
}
